<template>
    <div class="gs-app gm-mail-app-choice">
        <div class="gm-mail-app-choice__grid flex flex-row w-full mt-8 mb-6 gap-5 justify-start">
            <div class="flex flex-col w-1/2">
                <div class="gm-mail-app-choice__card border w-full mr-6 bg-white rounded-lg cursor-pointer p-6 hover:cursor-pointer border-solid h-full relative border-grey-300"
                    @click="goToDashboard">
                    <div class="flex justify-center items-center mb-3">
                        <img src="https://assets.grooveapps.com/css/groovemail.svg" alt="" class="w-20" />
                    </div>

                    <div class="mb-1 font-semibold text-center">
                        <p class="text-md text-grey-700">
                            GrooveMail
                        </p>
                    </div>

                    <div class="mb-1 text-center">
                        Simple yet powerful email marketing automation.
                    </div>
                </div>
            </div>
            <div class="flex flex-col w-1/2">
                <div class="gm-mail-app-choice__card border w-full mr-6 bg-white rounded-lg cursor-pointer p-6 hover:cursor-pointer border-solid h-full relative border-grey-300"
                    @click="goToDashboardTinyEmail">
                    <div class="flex justify-center items-center mb-3">
                        <svg width=" 100%" style="fill: #008060; color: #008060;" class="w-48 my-5" height=" 100%"
                            viewBox="0 0 168 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_757_1143)">
                                <path
                                    d="M50.3497 24.4671C49.5771 25.102 48.5273 25.4891 47.507 25.4891C45.2991 25.4891 43.7522 23.8881 43.7522 21.5965V13.2045H41.6001V10.8867H43.7522V6.96786H46.4293V10.8867H49.7969V13.2045H46.4293V21.403C46.4293 22.397 47.092 23.1139 47.8925 23.1139C48.4994 23.1139 49.0522 22.8924 49.3557 22.5889L50.3497 24.4655V24.4671Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M52.1426 6.85635C52.1426 6.00008 52.8611 5.22748 53.7993 5.22748C54.6818 5.22748 55.4282 6.00008 55.4282 6.85635C55.4282 7.71261 54.6835 8.5131 53.7993 8.5131C52.8611 8.5131 52.1426 7.7405 52.1426 6.85635ZM52.4182 10.8867H55.151V25.1578H52.4182V10.8867Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M71.023 16.0751V25.1561H68.346V16.5443C68.346 14.4184 66.9927 12.9289 65.062 12.9289C63.1313 12.9289 61.363 14.2264 61.1415 15.9094V25.1561H58.4087V10.8867H61.1415V12.9568C61.9978 11.5494 63.7366 10.5553 65.6689 10.5553C68.8151 10.5553 71.0246 12.8469 71.0246 16.0768L71.023 16.0751Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M73.9311 29.5178L74.538 27.4198C75.0908 27.7232 75.7257 27.861 76.2768 27.861C77.1593 27.861 77.7679 27.5854 78.237 26.7571L78.9555 25.2397L72.8271 10.8867H75.7535L80.335 22.1493L84.6689 10.8867H87.5116L81.2176 26.4552C80.1956 29.0224 78.6783 30.0985 76.636 30.1264C75.6699 30.1264 74.6758 29.9049 73.9311 29.5194V29.5178Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M160.867 11.5379C160.399 11.264 160.029 10.8933 159.755 10.4258C159.481 9.95825 159.345 9.45138 159.345 8.9035C159.345 8.35563 159.481 7.84876 159.755 7.38126C160.029 6.91376 160.399 6.54304 160.867 6.2691C161.334 5.99516 161.841 5.85901 162.389 5.85901C162.937 5.85901 163.444 5.9968 163.911 6.2691C164.379 6.54304 164.75 6.91376 165.024 7.38126C165.298 7.84876 165.434 8.35727 165.434 8.9035C165.434 9.44974 165.296 9.95825 165.024 10.4258C164.75 10.8933 164.379 11.264 163.911 11.5379C163.444 11.8118 162.935 11.948 162.389 11.948C161.843 11.948 161.334 11.8118 160.867 11.5379ZM163.6 10.9884C163.966 10.7719 164.258 10.4782 164.474 10.1075C164.691 9.7368 164.799 9.33492 164.799 8.9035C164.799 8.47209 164.691 8.05872 164.474 7.69292C164.258 7.32712 163.967 7.03514 163.6 6.81862C163.232 6.60209 162.83 6.49383 162.389 6.49383C161.948 6.49383 161.554 6.60209 161.185 6.81862C160.814 7.03514 160.521 7.32548 160.304 7.69292C160.088 8.05872 159.98 8.46389 159.98 8.9035C159.98 9.34312 160.089 9.73516 160.311 10.101C160.531 10.4668 160.824 10.7604 161.192 10.9818C161.558 11.2033 161.958 11.3132 162.389 11.3132C162.821 11.3132 163.234 11.2049 163.6 10.9884ZM161.369 7.4075H162.64C162.896 7.4075 163.121 7.501 163.316 7.68472C163.51 7.87008 163.608 8.09481 163.608 8.36055C163.608 8.56395 163.544 8.74603 163.416 8.91007C163.288 9.0741 163.131 9.18072 162.945 9.23486L162.919 9.2611L163.713 10.3733V10.3995H163.024L162.296 9.28735H161.977V10.3995H161.369V7.4075ZM162.586 8.73127C162.701 8.73127 162.798 8.69682 162.878 8.62464C162.957 8.55411 162.998 8.46553 162.998 8.36055C162.998 8.26377 162.96 8.17683 162.885 8.10301C162.809 8.02756 162.714 7.98983 162.599 7.98983H161.977V8.73127H162.586Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M93.86 9.86474V13.6458H103.382V17.3169H93.86V21.485H104.376V25.1561H89.7739V6.19363H104.376V9.86474H93.86Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M128.916 16.0751V25.184H125.051V16.7657C125.051 15.1089 124.003 13.9509 122.512 13.9509C120.911 13.9509 119.751 15.0269 119.751 16.5459V25.1856H115.886V16.7673C115.886 15.1106 114.838 13.9525 113.375 13.9525C111.746 13.9525 110.614 15.0286 110.614 16.5475V25.1594H106.584V10.8867H110.614V12.7632C111.305 11.41 112.712 10.5553 114.479 10.5553C116.439 10.5553 118.122 11.5494 119.006 13.1504C119.751 11.5773 121.518 10.5553 123.644 10.5553C126.624 10.5553 128.916 12.8469 128.916 16.0768V16.0751Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M144.262 16.6279V25.1578H140.369V23.7225C139.347 24.8822 137.72 25.4891 136.173 25.4891C133.137 25.4891 130.791 23.6667 130.791 20.9339C130.791 18.201 133.414 16.1867 136.726 16.1867C137.886 16.1867 139.155 16.4344 140.369 16.9051V16.6296C140.369 15.1122 139.431 13.7868 137.085 13.7868C135.76 13.7868 134.518 14.2281 133.386 14.8088L132.033 12.1317C134.047 11.1098 136.007 10.5586 137.995 10.5586C141.722 10.5586 144.262 12.9043 144.262 16.6312V16.6279ZM140.369 20.6583V19.3329C139.459 19.0015 138.409 18.808 137.305 18.808C135.842 18.808 134.682 19.6642 134.682 20.8223C134.682 21.9804 135.704 22.6989 137.083 22.6989C138.629 22.6989 140.092 21.9804 140.367 20.6566L140.369 20.6583Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M146.772 6.71855C146.772 5.58671 147.739 4.56641 148.98 4.56641C150.222 4.56641 151.133 5.58835 151.133 6.71855C151.133 7.93241 150.166 8.92646 148.98 8.92646C147.794 8.92646 146.772 7.93241 146.772 6.71855ZM146.938 10.8867H150.968V25.1578H146.938V10.8867Z"
                                    fill="currentColor"></path>
                                <path d="M153.784 5.86227H157.814V25.1561H153.784V5.86227Z" fill="currentColor"></path>
                                <path
                                    d="M27.4817 4.73941C24.6143 2.01372 20.8117 0.496058 16.8595 0.500008H16.8089C12.3791 0.514261 8.17071 2.29768 4.95917 5.52066C1.74763 8.74365 -0.0141367 12.9541 8.54393e-05 17.3739C0.0129743 21.3652 1.65119 25.1552 4.61295 28.0459C7.55827 30.9206 11.3956 32.5 15.4236 32.5H15.4738C19.1275 32.4884 21.8817 31.6715 24.9804 29.681C24.9989 29.6692 25.0148 29.6539 25.0273 29.6358C25.0397 29.6178 25.0484 29.5974 25.0528 29.5759C25.0572 29.5544 25.0573 29.5322 25.0531 29.5106C25.0489 29.4891 25.0405 29.4686 25.0284 29.4503L24.3057 28.3719C24.2821 28.3366 24.2458 28.3118 24.2044 28.3027C24.163 28.2936 24.1197 28.3008 24.0835 28.3229C21.2084 30.0725 18.8151 30.7584 15.5476 30.7691H15.5031C8.11871 30.7691 1.86852 24.6225 1.84496 17.3262C1.83208 13.3835 3.39384 9.62734 6.24183 6.7491C9.08981 3.87087 12.8133 2.28209 16.7307 2.26962H16.7751C24.0497 2.26962 30.2066 8.03143 30.2288 14.872C30.2368 17.3583 29.6839 19.3947 28.6288 20.7612C27.7844 21.8556 26.6288 22.4859 25.4631 22.4894H25.4506C24.7066 22.4894 24.0871 22.2667 23.6586 21.8516C23.2195 21.4236 22.9857 20.7902 22.9835 20.0201C22.9857 19.8804 22.995 19.741 23.0115 19.6023C23.0158 19.5623 23.0054 19.5222 22.9823 19.4893C22.9591 19.4565 22.9248 19.4333 22.8857 19.4241L19.8146 18.6914C19.7785 18.6804 19.7396 18.6822 19.7046 18.6964C19.6695 18.7107 19.6404 18.7366 19.6222 18.7698C18.4667 20.8744 16.5827 22.0373 14.3165 22.0445C11.7867 22.0511 10.0943 20.3519 10.0014 17.7186V17.6928C10.0276 16.2982 10.0338 15.9668 10.4605 14.6155C11.3805 11.8744 13.7311 10.1658 16.5938 10.1565H16.6315C18.0538 10.1565 18.9222 10.417 19.3618 10.9747C19.8342 11.5742 20.2062 12.2766 19.1546 13.6712C17.7102 15.5865 13.7685 16.6439 11.4854 15.7321C11.4278 15.7082 11.3719 15.6807 11.3178 15.6497C11.2954 15.6374 11.2705 15.6305 11.2449 15.6295C11.2194 15.6284 11.194 15.6334 11.1707 15.6439C11.1474 15.6543 11.1268 15.67 11.1107 15.6898C11.0945 15.7096 11.0833 15.733 11.0778 15.758C10.9367 16.3577 10.8769 16.9737 10.9 17.5895C10.9132 17.8413 10.9483 18.0916 11.0049 18.3373C11.0113 18.3662 11.0253 18.3929 11.0455 18.4145C11.0656 18.4361 11.0912 18.4519 11.1196 18.4602C11.8386 18.6616 12.5824 18.7604 13.3289 18.7538C16.0142 18.7538 20.32 16.8385 21.6457 14.464C22.7973 12.7425 22.2844 10.7671 21.2644 9.573C19.6711 7.70718 17.8284 7.46042 16.2244 7.46576C13.9151 7.47556 11.5458 8.55925 9.73337 10.4433C7.82938 12.4192 6.78538 14.9865 6.79383 17.6741C6.80583 21.8378 9.59737 24.741 13.5845 24.741H13.6111C16.7875 24.7307 18.9089 22.8021 19.9911 21.4783C20.5609 23.5072 22.2786 24.7053 24.6533 24.7053H24.6764C26.5622 24.6991 28.3959 23.8056 29.7075 22.2556C31.2186 20.4695 32.0097 17.9155 31.9999 14.8698C31.9875 11.0825 30.383 7.48536 27.4817 4.73941Z"
                                    fill="currentColor"></path>
                            </g>
                            <defs>
                                <clipPath id="clip0_757_1143">
                                    <rect width="168" height="32" fill="currentColor" transform="translate(0 0.5)">
                                    </rect>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>

                    <div class="mb-1 font-semibold text-center">
                        <p class="text-md text-grey-700">
                            Tiny Email
                        </p>
                    </div>

                    <div class="mb-1 text-center">
                        Easy email marketing & workflows.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import auth from '@groovepages/gd-lib/auth';
import api from '@groovepages/gd-lib/api';

export default {
    middleware: 'auth',
    layout: 'defaultWithSidebar',
    data() {
        return {};
    },
    computed: {
        ...mapGetters(['metaData', 'user']),
    },

    async created() {
        if (user.metadata.default_email_app == 'groovemail') {
            this.goToDashboard();
        }

        if (user.metadata.default_email_app == 'tinyemail') {
            this.goToDashboardTinyEmail();
        }
    },

    methods: {
        goToDashboard() {
            this.updateMeta('groovemail');
            this.$router.push({ name: 'dashboard' });
        },
        goToDashboardTinyEmail() {
            this.updateMeta('tinyemail');
            this.$router.push({ name: 'dashboard-tinyemail' });
        },
        updateMeta(default_email_app) {
            auth.updateMeta({
                default_email_app: default_email_app
            });
            api.post(
                `${window.gdEnv.VUE_APP_API_URL}/groovedigital/auth/users/update-meta/${auth.authenticatedUser().id}`, {
                default_email_app: default_email_app
            }
            ).catch(() => { });
        }
    }
};
</script>

<style scoped>
.gm-mail-app-choice {
    min-height: 100%;
    padding: 28px;
    color: var(--gs-foreground);
    background: var(--gs-background);
}

.gm-mail-app-choice__grid {
    max-width: 960px;
    margin-right: auto;
    margin-left: auto;
}

.gm-mail-app-choice__card {
    border-color: var(--gs-border);
    border-radius: var(--gs-radius-lg);
    box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
    .gm-mail-app-choice {
        padding: 16px;
    }

    .gm-mail-app-choice__grid {
        flex-direction: column;
    }

    .gm-mail-app-choice__grid > .w-1\/2 {
        width: 100%;
    }

    .gm-mail-app-choice__card {
        margin-right: 0;
        border-radius: var(--gs-radius-md);
    }
}
</style>
